import { parseISO } from "date-fns";

// Timeline configuration
export const TIMELINE_START_HOUR = 6;  // 6 AM
export const TIMELINE_END_HOUR = 22;   // 10 PM
export const HOUR_HEIGHT_PX = 48;      // Height per hour in pixels
export const MIN_DURATION_MINUTES = 15; // Minimum appointment duration
export const LONG_PRESS_DURATION = 500; // ms for touch drag activation

export const STATUS_COLORS = {
    scheduled: {
        bg: "bg-blue-50",
        border: "border-l-blue-400",
        text: "text-blue-800"
    },
    completed: {
        bg: "bg-green-50",
        border: "border-l-green-400",
        text: "text-green-800"
    },
    cancelled: {
        bg: "bg-red-50",
        border: "border-l-red-400",
        text: "text-red-800"
    }
};

/**
 * Calculate top position and height for an appointment block
 */
export const getAppointmentPosition = (dateTime, durationMinutes) => {
    const date = parseISO(dateTime);
    const hours = date.getHours();
    const minutes = date.getMinutes();

    const startOffset = (hours - TIMELINE_START_HOUR) + (minutes / 60);
    const durationHours = (durationMinutes || 30) / 60;

    return {
        top: startOffset * HOUR_HEIGHT_PX,
        height: Math.max(durationHours * HOUR_HEIGHT_PX, 24) // Minimum 24px height
    };
};

/**
 * Calculate time from pixel offset
 */
export const getTimeFromOffset = (offsetY, date) => {
    const hoursFromStart = offsetY / HOUR_HEIGHT_PX;
    const totalHours = TIMELINE_START_HOUR + hoursFromStart;
    const hours = Math.floor(totalHours);
    const minutes = Math.round((totalHours - hours) * 60 / 15) * 15; // Snap to 15-min intervals

    const resultDate = new Date(date);
    resultDate.setHours(Math.max(TIMELINE_START_HOUR, Math.min(hours, TIMELINE_END_HOUR)), minutes % 60, 0, 0);
    return resultDate;
};

/**
 * Format date for datetime-local input
 */
export const formatForInput = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const mins = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${mins}`;
};

/**
 * Generate hour labels for the timeline
 */
export const generateHourLabels = () => {
    const labels = [];
    for (let hour = TIMELINE_START_HOUR; hour <= TIMELINE_END_HOUR; hour++) {
        const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
        const ampm = hour < 12 ? 'AM' : 'PM';
        labels.push({
            hour,
            label: `${displayHour} ${ampm}`
        });
    }
    return labels;
};
